import { render, staticRenderFns } from "./DashboardAdmin.vue?vue&type=template&id=500a0d30&scoped=true"
import script from "./DashboardAdmin.vue?vue&type=script&lang=js"
export * from "./DashboardAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500a0d30",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('500a0d30')) {
      api.createRecord('500a0d30', component.options)
    } else {
      api.reload('500a0d30', component.options)
    }
    module.hot.accept("./DashboardAdmin.vue?vue&type=template&id=500a0d30&scoped=true", function () {
      api.rerender('500a0d30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/DashboardAdmin.vue"
export default component.exports